module.exports = __webpack_public_path__ + "img/DNARepair-OVCA_10X_TIP.7cbcf04f.png";